import axios from 'axios';

export default axios.create({
	baseURL:
		'https://learn-react-c38e3-default-rtdb.europe-west1.firebasedatabase.app/'
});
